Vue.component('billing-contact-row-item', require('./components/BillingContactRowItem.vue').default);
Vue.component('csv-uploader', require('./components/CSVUploader.vue').default);
Vue.component('payment-form', require('./components/PaymentForm.vue').default);
Vue.component('payment-row-item', require('./components/PaymentRowItem.vue').default);
Vue.component('site-search', require('./components/SiteSearch.vue').default);
Vue.component('sub-payment-form', require('./components/SubscriptionPaymentForm.vue').default);
Vue.component('terms-scroller', require('./components/TermsScroller.vue').default);
Vue.component('theme-editor', require('./components/ThemeEditor.vue').default);

// Delay function
// TODO: Replace this with _debounce
var delay = (function(){
	var timer = 0;
	return function(callback, ms) { clearTimeout (timer); timer = setTimeout(callback, ms); };
})();

// Main app
const app = new Vue({
  el: '#app',
  // props: ['bgColor', 'bgLogoUrl', 'fontColor'],
  data: function() {
    return {
      canContinue: false,
      colorBackground: this.bgColor,
      colorFont: this.fontColor,
      displayNextButton: true,
      email: '',
      logoURL: this.bgLogoUrl,
      projectID: 0,
      projectName: '',
      singleEditActiveRefID: 0,

      testArray: [],
      testObj: {},

      googleReCaptchaToken: '',
    };
  },
  methods: {
    copySiteInfo: function(sourceRef, targetRefs, e) {
      // These are the values that need to copy from the source to the target(s)
      var fields = [
        'fullName',
        'legalEntity',
        'phone',
        'email',
        'addressStreet1',
        'addressStreet2',
        'addressCity',
        'addressStateID',
        'addressZIP',
      ];

      // Loop through the targets, copying data
      targetRefs.split(',').forEach(function(targetID) {
        // Loop through the fields and do the copying
        if(targetID != sourceRef) {
          fields.forEach(function(fieldName) {
            sourceRefName = 'site-' + sourceRef;
            targetRefName = 'site-' + targetID;

            // If the source value exists and target is empty...
            if(this.$refs[sourceRefName][fieldName] && (this.$refs[targetRefName][fieldName] == '')) {
              this.$refs[targetRefName][fieldName] = this.$refs[sourceRefName][fieldName];
            }
          }.bind(this));
        }
      }.bind(this));
    },
    copyBillingInfo: function(sourceRef, targetRef, e) {
        console.log(e);
        if(e.target.checked == true) {
            console.log('copying source ref ' + sourceRef + ' to ' + targetRef);

            this.$refs[targetRef + '_street1'].value = this.$refs[sourceRef + '_street1'].value;
            this.$refs[targetRef + '_street2'].value = this.$refs[sourceRef + '_street2'].value;
            this.$refs[targetRef + '_city'].value = this.$refs[sourceRef + '_city'].value;
            this.$refs[targetRef + '_state'].value = this.$refs[sourceRef + '_state'].value;
            this.$refs[targetRef + '_zip'].value = this.$refs[sourceRef + '_zip'].value;
            this.$refs[targetRef + '_country'].value = this.$refs[sourceRef + '_country'].value;

            this.$refs[targetRef + '_poc_name'].value = this.$refs[sourceRef + '_poc_name'].value;
            this.$refs[targetRef + '_poc_phone'].value = this.$refs[sourceRef + '_poc_phone'].value;
            this.$refs[targetRef + '_poc_email'].value = this.$refs[sourceRef + '_poc_email'].value;

            // console.log(this.$refs[sourceRef + '_street1'].value);
            // console.log(this.$refs[sourceRef + '_street2'].value);
            // console.log(this.$refs[sourceRef].value);
        }
        else {
            console.log('doing nothing or resetting the form');

            this.$refs[targetRef + '_street1'].value = '';
            this.$refs[targetRef + '_street2'].value = '';
            this.$refs[targetRef + '_city'].value = '';
            this.$refs[targetRef + '_state'].value = '';
            this.$refs[targetRef + '_zip'].value = '';
            this.$refs[targetRef + '_country'].value = '';

            this.$refs[targetRef + '_poc_name'].value = '';
            this.$refs[targetRef + '_poc_phone'].value = '';
            this.$refs[targetRef + '_poc_email'].value = '';
        }
    },
    fetchProjectByName: function(name) {
      console.log('Fetching project by name: ' + name);

      axios.get('/api/project/fetch_by_name?name=' + name)
        .then(function(response) {
          console.log(response.data);
          if(response.data.data) {
            this.projectID = response.data.data.id;

            if(response.data.data.theme) {
              theme = response.data.data.theme;

              this.colorBackground = theme.bgColor;
              this.colorFont = theme.fontColor;
              // TODO: Change logo based on isDark value

              if(theme.logo && theme.logo.url) { this.logoURL = theme.logo.url; }
            }
          }
          else {
            this.projectID = 0;
            this.colorBackground = this.bgColor;
            this.colorFont = this.fontColor;
            this.logoURL = '';
          }
        }.bind(this))
        .catch(function(error) { console.error(error); }.bind(this))
        .finally(function() { /* */ }.bind(this));
    },
    setSingleEditActiveRefID: function(refID) {
      console.log('Setting single-edit active ref ID to: ' + refID);
      this.singleEditActiveRefID = refID;
    },
    toggleCheckboxByRef: function(targetRefs, e) {
      var targets = targetRefs.split(',');
      for(i=0; i<targets.length; i++) {
        this.$refs[targets[i]].checked = e.target.checked;
      }
    },
    toggleElementByRef: function(refID) {
      var refStyle = this.$refs[refID].style

      console.log('Style for ref: ' + refID)
      console.log(refStyle.animationName);
      console.log(refStyle);
      // this.$refs[sourceRef + '_street1'].value;
    },
  },
  mounted: function() {
    // Enable tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  },
  watch: {
    projectName: function() { delay(function() { this.fetchProjectByName(this.projectName); }.bind(this), 700); },
  }
});
